import util   from '../common/AppUtil';

const ServerMode = 0;
const ApiCode = "login";

export default {
  requestLogin: function(params) {    
    return util.callServerPost(ServerMode,ApiCode,params,"login");
  },
  savePassword: function(params) {    
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },
  resetLogin: function(params) {    
    return util.callServerPost(ServerMode,ApiCode,params,"reset");
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js